export { default as CollegeHeader } from "./collegeheader/CollegeHeader";
export { default as CollegeHeaderEdit } from "./collegeheader/CollegeHeaderEdit";
export { default as CollegeHero } from "./collegehero/CollegeHero";
export { default as CollegeHeroEdit } from "./collegehero/CollegeHeroEdit";
export { default as CollegeAbout } from "./collegeabout/CollegeAbout";
export { default as CollegeAboutEdit } from "./collegeabout/CollegeAboutEdit";
export { default as CollegePrograms } from "./collegeprograms/CollegePrograms";
export { default as CollegeProgramsEdit } from "./collegeprograms/CollegeProgramsEdit";
export { default as CollegeStats } from "./collegestats/CollegeStats";
export { default as CollegeStatsEdit } from "./collegestats/CollegeStatsEdit";
export { default as CollegeFooter } from "./collegefooter/CollegeFooter";
export { default as CollegeFooterEdit } from "./collegefooter/CollegeFooterEdit";
